import { Paper, Skeleton, Stack } from "@mui/material";

export function PostCardSkeleton() {
  return (
    <Paper variant="outlined" data-testid="post-skeleton" sx={{ p: 2 }}>
      <Stack spacing={2} aria-hidden>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
          <Skeleton
            variant="circular"
            width={42}
            height={42}
            data-testid="skeleton-shape"
            aria-hidden
          />
          <Stack spacing={0.5} sx={{ flex: 1 }}>
            <Skeleton width="34%" data-testid="skeleton-shape" aria-hidden />
            <Skeleton width="22%" data-testid="skeleton-shape" aria-hidden />
          </Stack>
        </Stack>
        <Stack spacing={0.5}>
          <Skeleton width="96%" data-testid="skeleton-shape" aria-hidden />
          <Skeleton width="72%" data-testid="skeleton-shape" aria-hidden />
        </Stack>
        <Skeleton
          variant="rounded"
          height={36}
          data-testid="skeleton-shape"
          aria-hidden
        />
      </Stack>
    </Paper>
  );
}
